<script setup>
import Slider from '@maison/components/organisms/Slider.vue';
import BackgroundVideo from '@maison/components/molecules/BackgroundVideo.vue';
import { computed, ref } from 'vue';
import PhxPicture from '@maison/components/common/PhxPicture.vue';

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
  medias: {
    type: Array,
    required: true,
  },
});

const sliderRef = ref(null);

const hasOneItem = computed(() => props.medias.length === 1);

const resetPosition = () => {
  if (sliderRef.value) {
    sliderRef.value.resetPosition();
  }
};

defineExpose({
  resetPosition,
});
</script>
<template>
  <slider
    ref="sliderRef"
    :class="['movement-details-panel__slider']"
    :aria-label="$t('Accessibility.productsSlider.ariaLabel')"
    has-pagination
    :slider-options="{}"
    :hide-footer="hasOneItem"
  >
    <template #default="{ sliderId }">
      <div
        v-for="(mediaItem, index) of medias"
        :key="`movement-media-${sliderId}-${index + 1}`"
        class="slider__item"
        role="tabpanel"
        :aria-labelledby="`pagination-${index + 1}`"
      >
        <div v-if="mediaItem.type === 'image'" class="picture">
          <PhxPicture v-bind="mediaItem" />
        </div>
        <background-video
          v-else-if="mediaItem.type === 'video'"
          v-bind="mediaItem"
          :video-id="`${id}-media-${index}`"
        />
      </div>
    </template>
  </slider>
</template>
